import { getLatLng } from '@api/google'
import { LaneInfo } from '@components/shared/LaneInfo'
import { calculateSphericalDistance } from '@utils/calculateSphericalDistance'

const METERS_TO_MILES_RATIO = 0.000621371192
const SEARCH_RADIUS_IN_MILES = 100

export type EnrollmentLocation = {
  locationCode: string
  name: string
  address: string
  location: any
  distance: number
  lanes: LaneInfo[]
  importantInfo?: string
  open?: boolean
}

export const determineMapZoomLevel = (
  locationsWithinRange: EnrollmentLocation[]
) => {
  const largestDistance = locationsWithinRange.reduce((acc, location) => {
    if (location?.distance > acc) acc = location?.distance
    return acc
  }, 0)

  return largestDistance > 20 ? 8 : largestDistance > 9 ? 10 : undefined
}

export const getNearbyEnrollmentLocations = async (
  enrollmentLocations: Record<string, any>,
  searchInput: string
) => {
  const searchCoords = await getLatLng(searchInput, enrollmentLocations)

  const enrollmentLocationsNearSearch: EnrollmentLocation[] = Object.values(
    enrollmentLocations
  )
    .map((enrollmentLocation: any) => {
      const distanceInMeters = calculateSphericalDistance(searchCoords as any, {
        lat: enrollmentLocation.latitude,
        lng: enrollmentLocation.longitude,
      })
      const distanceInMiles = distanceInMeters * METERS_TO_MILES_RATIO
      const roundedDistanceInMiles = Math.round(distanceInMiles * 10) / 10

      return {
        locationCode: enrollmentLocation?.uid,
        distance: roundedDistanceInMiles,
        name: enrollmentLocation?.name,
        location: {
          lat: Number(enrollmentLocation.latitude),
          lng: Number(enrollmentLocation.longitude),
        },
        address: `${enrollmentLocation?.address1} ${
          enrollmentLocation?.address2 || ''
        } ${enrollmentLocation?.city}, ${enrollmentLocation?.state}`,
        lanes: enrollmentLocation?.lanes,
        open: enrollmentLocation?.open,
        importantInfo: enrollmentLocation?.importantInfo,
      }
    })
    // return enrollment locations within SEARCH_RADIUS_IN_MILES miles
    .filter(
      (enrollmentLocation) =>
        enrollmentLocation.distance < SEARCH_RADIUS_IN_MILES
    )

  return { enrollmentLocationsNearSearch, location }
}
